import { BINNED_REPORTS, INTERNAL_PROPS, SERVLET_COMMAND, ServletCmds } from '../../constants/ServletCommands'
import { SERVLET_ACTION, ServletActions } from '../../constants/React/ServletActions/ServletActions'
import { ReportListResponse } from '../Types/Types'
import { requestGetJsonURL } from '../../constants/ApiConstants'
import { requestGetJSON, StatusCodes } from './REST/RESTAPIClient'
import { mapRequestResults } from './REST/RESTClient'
import { RequestResults } from '../Types/MainMenu/ReportListTypes'

/**
 * Retrieves the list of reports.
 *
 * @param reportTypesToExclude List of report types to exclude from response.
 */
export const retrieveReportList = async (...reportTypesToExclude: number[]): Promise<Definable<ReportListResponse>> => {
    let params: Record<string, string> = {
        [SERVLET_COMMAND]: ServletCmds.RPT_LIST,
        [SERVLET_ACTION]: ServletActions.GET,
        [INTERNAL_PROPS]: 'true',
        [BINNED_REPORTS]: 'true'
    }

    if (reportTypesToExclude.length > 0) {
        // List of report types to return has to be provided as a CStringRangeList compatible value.
        // For this case, we list all report types we want to exclude as comma separated values.
        params = {
            ...params,
            ReportTypes: reportTypesToExclude.map((reportTypeToExclude) => `!${reportTypeToExclude}`).join(',')
        }
    }

    const response: Definable<ReportListResponse> = await requestGetJSON<RequestResults<ReportListResponse>>(
        requestGetJsonURL(params),
        { cacheTime: 1000 }
    )
        .then(mapRequestResults)
        .catch((error) => {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (error?.HTTPStatus === StatusCodes.NOT_FOUND && error?.JSONObject) {
                // This is the workaround for the incorrect Akixi response type where 404 HTTP status code is returned,
                // where an error is thrown from the API request implementation.
                return { ReportList: [] }
            }
            throw error
        })

    if (!response) {
        // This is the workaround for the incorrect Akixi response type where 404 HTTP status code
        // is in case of no reports considered as successful.
        return { ReportList: [] }
    }
    return response
}
